import { AxiosResponse } from 'axios'
import { request } from '../request'
import { DatosHistorico } from '@models/api/DatosHistorico'
import { StationsTemporalType } from '@enums/StationsTemporalType'

export const historic = {
  getObservacionHistorico: function (
    stationId: string | number,
    type: StationsTemporalType,
    year: string | number,
    month: string | number,
    day: string | number
  ): Promise<AxiosResponse<DatosHistorico>> {
    return request.get(
      `historic?stationId=${stationId}&type=${StationsTemporalType.getApiType(
        type
      )}&year=${year}&month=${month}&day=${day}`
    )
  }
}
